<template>
  <b-row v-if="items.length > 0">
    
    <b-col lg="4" v-for="item in items" :key="item.id">
      <b-card class="card-congratulation-medal">
        <h3>تهانينا 🎉</h3>
        <hr />
        <h5 class="mb-1">
          <span class="font-weight-bolder">اسم الشهادة :</span>
          {{ item.certificate.name }}
        </h5>
        <h5 class="mb-1">
          <span class="font-weight-bolder">نوع البرنامج :</span>
          {{ item.certificate.program_type }}
        </h5>
        <h5 class="mb-1">
          <span class="font-weight-bolder">التاريخ :</span>
          {{ item.certificate_date }}
        </h5>
        <hr />

        <b-button block v-b-modal.modal-xl @click="view(item)" variant="relief-primary">
          عرض
        </b-button>
        <b-img :src="require('@/assets/images/illustration/badge.svg')" class="congratulation-medal" />
      </b-card>
    </b-col>
    <b-modal id="modal-xl" ok-only centered size="xl">
      <page size="A4" :layout="data.type" :style="{
        'background-image': 'url(' + config.serverUrl + data.image_path + ')',
      }">
        <div class="card-body target" ref="target">
          <div :data-index="index" v-for="(item, index) in data.text" :key="index" v-html="item.text"
            style="position: absolute" :style="{
              top: item.top + 'px',
              right: item.left + 'px',
            }"></div>
        </div>
      </page>
    </b-modal>
  </b-row>
  <b-row v-else>
    <b-col lg="4" >
      <b-card class="card-congratulation-medal">
        <h3>{{$t('certificates.certificate_yet')}}</h3>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import CertificationsController from "@/Controllers/CertificationsController";
import config from "../../../config/config";
import Auth from "@/Apis/Auth";

export default {
  data() {
    return {
      items: [],
      data: {},
      config: config,
    };
  },
  // mounted(){
  //   this.$mobileTitle=this.$i18n.t('certificates.assign_certificate')

  // },
  async created() {
    this.items = await new CertificationsController().student();
    console.log(this.$mobileTitle);
    this.$mobileTitle.label=this.$i18n.t('certificates.certificate'); 
    this.$forceUpdate();
     
  },
  methods: {
    view(item) {
      this.data = item.certificate;
      let text = item.certificate.meta_data
        .replace("{{full_name}}", Auth.USER.full_name)
        .replace("{{first_name}}", Auth.USER.first_name)
        .replace("{{certification_date}}", item.certificate_date)
        .replace("{{last_name}}", Auth.USER.last_name);
      //

      this.data.text = JSON.parse(text);
      console.log(this.data.text);
    },
  },
};
</script>


<style>
page {
  background: white;
  display: block;
  margin: 0 auto;
  margin-bottom: 0.5cm;
  box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
}

page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
  background-size: 21cm 29.7cm;
}

page[size="A4"][layout="horizontal"] {
  width: 29.7cm;
  height: 21cm;
  background-size: 29.7cm 21cm;
}

page[size="A3"] {
  width: 29.7cm;
  height: 42cm;
}

@media print {

  body,
  page {
    margin: 0;
    box-shadow: 0;
  }
}
</style>